import { memo, useEffect, useState, useRef } from "react";
import {
  GoogleMap,
  LoadScript,
  MarkerClusterer,
  Marker,
  InfoWindow,
  Polyline,
} from "@react-google-maps/api";
import HelicopterIcon from "../../../../assets/img/Basic_red_dot1.png";
import GreenHelicopterIcon from "../../../../assets/img/Basic_green_dot1.png";
import React from "react";
import PolylineRoute from "./polyline-route";
import LeakPopup from "./leakPopup";
import "./map-op-details.scss"

const SimpleMap = (props: any) => {
  const setHeight = props.height;
  const [selectedPlace, setSelectedPlace] = useState<any>(null);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [infoOpen, setInfoOpen] = useState(false);
  const [hideHeli, setHideHeli] = useState(false);
  const [colorRoute, setcolorRoute] = useState<any>([]);
  const [RouteNames, setRouteNames] = useState<any>([]);
  const [map, setMap] = useState<any>(null);
  const [mapMarker, setMapMarker] = useState<any>([]);
  const [RouteValues, setRouteValues] = useState([]);
  const [RouteValues_joints, setRouteValues_joints] = useState([]);

  const [defaultMapOptions, setdefaultMapOptions] = useState<any>({
    fullscreenControl: false,
    mapTypeId: "satellite",
  });
  let map_center_lat: any = (props?.data && props?.data?.mapData) ? props.data?.mapData[0]?.latitude : '29.55657391228237';
  let map_center_lng: any = (props?.data && props?.data?.mapData) ? props.data?.mapData[0]?.longitude : '-95.25194196045129';
  useEffect(() => {
    setActiveMarker(null);
    if (map) {
      map.setZoom(19);
    }
    setHideHeli(true);
    let markers_values: any = [];
    let route_values: any = [];
    let route_values_joints: any = [];
    let route_color_values: any = [];
    let route_names: any = [];
    let master_route_values: any = [];
    let master_route_values_joints: any = [];

    props.data.mapData && props.data.mapData[0]?.routes.map((route_vals: any, i_main: any) => {
      route_values = [];
      // routeName
      route_color_values.push(route_vals?.color);
      route_names.push(route_vals?.routeName);
      route_vals.sequence.map((sequence_val: any, i_child: any) => {
        markers_values.push({
          lat: Number(sequence_val.lat),
          lng: Number(sequence_val.lon),
          RouteName: route_vals?.routeName,
          title: props?.data?.mapData[0]?.siteName,
          obs_sequence: sequence_val?.obs_sequence,
          emissionData: sequence_val.leakDetails,
          hasEmission: sequence_val.leakDetails.length > 0 ? 1 : 0,
          Total_Targets: sequence_val.leakDetails.length,
        });

        route_values.push({
          lat: Number(sequence_val.lat),
          lng: Number(sequence_val.lon),
        });

        if (route_vals.sequence.length - 1 == i_child) {
          if (props.data.mapData && props.data.mapData[0]?.routes[i_main + 1] != undefined) {
            // if (
            //   props.data.mapData[0]?.routes[i_main + 1]?.sequence[0] !=
            //   undefined
            // ) {
            //   route_values.push({
            //     lat: Number(
            //       props.data.mapData[0]?.routes[i_main + 1].sequence[0].lat
            //     ),
            //     lng: Number(
            //       props.data.mapData[0]?.routes[i_main + 1].sequence[0].lon
            //     ),
            //   });
            // }
            route_values_joints.push({
              lat: (props?.data && props?.data?.mapData) ? Number(props.data.mapData[0]?.routes[i_main].sequence[i_child].lat) : '29.55657391228237',
              lng: (props?.data && props?.data?.mapData) ? Number(props.data.mapData[0]?.routes[i_main].sequence[i_child].lon) : '-95.25194196045129',
            });

            route_values_joints.push({
              lat: (props?.data && props?.data?.mapData) ? Number(props.data.mapData[0]?.routes[i_main + 1]?.sequence[0]?.lat) : '29.55657391228237',
              lng: (props?.data && props?.data?.mapData) ? Number(props.data.mapData[0]?.routes[i_main + 1]?.sequence[0]?.lon) : '-95.25194196045129',
            });
          }
        }
      });
      master_route_values_joints.push(route_values_joints);
      master_route_values.push(route_values);
    });

    setcolorRoute(route_color_values);
    setRouteNames(route_names);
    setMapMarker(markers_values);
    setRouteValues(master_route_values);
    setRouteValues_joints(master_route_values_joints);
  }, [props]);

  const onLoad = React.useCallback(function callback(map: any) {
    map.setZoom(19);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map: any) {
    setMap(null);
  }, []);

  const setMapContainerHeight: any = setHeight ? "94vh" : "500px";
  const mapContainerStyle: any = {
    height: setMapContainerHeight,
    width: "100%",
  };
  const [activeMarker, setActiveMarker] = useState(null);

  const center: any = {
    lat: Number(map_center_lat),
    lng: Number(map_center_lng),
  };

  const handleActiveMarker = (marker: any) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  // Check frame end
  return (
    <LoadScript googleMapsApiKey="AIzaSyCdsXnMXcV_vTCPjTd5tHGCi2Oed3hVKEQ">
      <GoogleMap
        onClick={(e: any) => {
          // console.log(e.latLng.lat());
          // console.log(e.latLng.lng());
        }}
        tilt={0}

        onLoad={onLoad}
        onUnmount={onUnmount}
        id="marker-example"
        mapContainerStyle={mapContainerStyle}
        zoom={10}
        center={center}
        options={defaultMapOptions}
      >
        <MarkerClusterer maxZoom={10} onClick={() => setHideHeli(true)}>
          {(clusterer) =>
            mapMarker.map((location: any, lid: any) => {
              let displayHeliCopIcon: any;
              let displayLeakCount: any = "";
              if (location.hasEmission == 0) {
                displayHeliCopIcon = GreenHelicopterIcon;
                displayLeakCount = " ";
              } else {
                displayHeliCopIcon = HelicopterIcon;
                displayLeakCount = location?.Total_Targets;
              }
              return (
                <Marker
                  onClick={() => {
                    handleActiveMarker(lid);
                  }}
                  visible={hideHeli}
                  key={lid}
                  position={{ lat: location.lat, lng: location.lng }}
                  clusterer={clusterer}
                  title={location?.title}
                  icon={displayHeliCopIcon}
                  label={{ text: `${displayLeakCount}`, color: "#fff" }}
                >
                  {activeMarker === lid ? (
                    <InfoWindow
                      onCloseClick={() => {
                        setActiveMarker(null);
                      }}
                      key={lid}

                    >
                      {/* leakpopup */}
                      <LeakPopup
                        locationData={location}
                        UnitPref={props.data.UnitPref}
                      />
                    </InfoWindow>
                  ) : null}
                </Marker>
              );
            })
          }
        </MarkerClusterer>
        {/* Updated scale */}
        {infoOpen && selectedMarker && (
          <InfoWindow
            // position={selectedPlace}
            anchor={selectedMarker}
            onCloseClick={() => setInfoOpen(false)}
          >
            <div>
              <div>
                <span style={{ float: "right" }}>{selectedPlace?.title}</span>
              </div>
              <div>
                <video width="300" height="150" controls>
                  <source src="/v1.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </InfoWindow>
        )}

        {RouteValues.map((val: any, i: any) => (
          <PolylineRoute
            RouteValues={val}
            colorRoute={colorRoute[i]}
            RouteNames={RouteNames[i]}
            Symbol="M -2,0 0,-2 2,0 z"
            isJoint={1}
            repeat="20px"
            scale="3"
          />
        ))}
        {RouteValues_joints?.map((val: any, i: any) => (
          <PolylineRoute
            RouteValues={val}
            colorRoute={"#0f52fe"}
            RouteNames={"Path"}
            Symbol={google.maps.SymbolPath.CIRCLE}
            isJoint={0}
            repeat="12px"
            scale="3"
          />
        ))}
      </GoogleMap>
    </LoadScript>
  );
};

export default SimpleMap;
